import { jsx } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { forwardRef } from "react";
import Paper from "@mui/material/Paper";
import { useStyles } from "./Paper.styles.js";
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if ("function" == typeof Object.getOwnPropertySymbols) ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function Paper_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = null != source ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else Paper_ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
const Paper_Paper = /*#__PURE__*/ forwardRef((props, ref)=>{
    const $ = c(10);
    let t0;
    if ($[0] !== props.border) {
        t0 = {
            border: props.border
        };
        $[0] = props.border;
        $[1] = t0;
    } else t0 = $[1];
    const { classes, cx } = useStyles(t0);
    let t1;
    if ($[2] !== classes.root || $[3] !== cx || $[4] !== props.className) {
        t1 = cx(props.className, "aqa_paper", classes.root);
        $[2] = classes.root;
        $[3] = cx;
        $[4] = props.className;
        $[5] = t1;
    } else t1 = $[5];
    let t2;
    if ($[6] !== props || $[7] !== ref || $[8] !== t1) {
        t2 = /*#__PURE__*/ jsx(Paper, _object_spread_props(_object_spread({}, props), {
            ref: ref,
            className: t1,
            "data-testid": "paper-test-id",
            children: props.children
        }));
        $[6] = props;
        $[7] = ref;
        $[8] = t1;
        $[9] = t2;
    } else t2 = $[9];
    return t2;
});
export { Paper_Paper as Paper };
